import * as constant from "../../routes/constants";
import { toast } from "react-toastify";

const toasty =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (action.type === constant.TOAST_ERROR) {
      return toast(action.payload.message, {
        type: "error",
        rtl: false,
        toastId: 1,
      });
    } else if (action.type === constant.TOAST_SUCCESS) {
      return toast(action.payload.message, { type: "success", toastId: 2 });
    } else if (action.type === constant.TOAST_WARNING) {
      return toast(action.payload.message, { type: "warning", toastId: 3 });
    } else {
      next(action);
    }
  };
export default toasty;
